import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash-es'

import { RichTextComponent } from '../../../sharedLegacy/components'

import './ThankYouMessageComponent.scss'

const ThankYouMessageComponent = ({ liveData }) => {
  if (isEmpty(liveData) || !isEmpty(liveData.after_webinar_link)) {
    return null
  }

  return (
    <div className="thank-you-message-component">
      <h3>{liveData.after_webinar_headline}</h3>
      <RichTextComponent text={liveData.after_webinar_message} />
    </div>
  )
}

ThankYouMessageComponent.propTypes = {
  liveData: PropTypes.object,
}

export default ThankYouMessageComponent
